import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Platform, Text, View} from 'react-native';

import {Marker, Callout, MapViewCluster} from 'src/Modules/Native/MapView';

import {MapMarker} from 'src/Modules/MapMarker';

import CarouselView from 'src/Modules/CommonView/CarouselView';

import {setCurrentHunt} from 'src/Redux/reducers/hunts.reducer.js';
import {navigationRef} from 'src/Nav/navigationHelpers';
import DelayedLoad from '../../Nav/DelayedLoad';
import {logCustomAnalyticsEvent} from '../../Utils/fireUtils';
const HuntLandingMap = () => {
  const dispatch = useDispatch();
  const region = useSelector((state) => state.location?.region || {});
  const huntsList = useSelector((state) => state.hunts.huntsList || {});
  const {latitude, longitude} = region;

  const [focusedLocationId, setFocusedLocationId] = useState(false);

  const mapRef = useRef();

  const handleSnapToMap = (location, zoom = 0.1) => {
    console.log('going to nearest hunt', {location});
    const {lat = 0, long = 0} = location;
    lat &&
      long &&
      mapRef?.current?.animateToRegion?.({
        latitude: parseFloat(lat || '0'),
        longitude: parseFloat(long || '0'),
        latitudeDelta: zoom,
        longitudeDelta: zoom,
      });
  };

  const goToClosestHunt = () => {
    const closestHunt = huntsList?.[0];
    if (closestHunt) {
      handleSnapToMap(closestHunt, 0.3);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      goToClosestHunt();
    }, 1500);
  }, []);

  console.log('map render', {latitude, longitude});
  return (
    <View
      testID="HomeLandingMap"
      style={{
        flex: 1,
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: -2,
      }}>
      <MapViewCluster
        style={{flex: 1}}
        key={latitude != 37.78825 && longitude != -122.4324 ? 1 : 0}
        showsUserLocation
        initialRegion={{
          latitude: 1.0 * (latitude || 0),
          longitude: 1.0 * (longitude || 0),
          latitudeDelta: 0.3,
          longitudeDelta: 0.3,
        }}>
        {!!huntsList?.length &&
          huntsList?.map?.((hunt) => {
            let location = hunt;
            if (location) {
              const markerPress = () => {
                if (location.hunt_id != focusedLocationId) {
                  setFocusedLocationId(location.hunt_id);
                  mapRef.current?.animateToRegion({
                    latitude: location.lat,
                    longitude: location.long,
                    latitudeDelta: 0.014,
                    longitudeDelta: 0.014,
                  });
                } else {
                  dispatch(setCurrentHunt(hunt));
                  navigationRef.navigate('ScavengerHuntInfoModal');
                  logCustomAnalyticsEvent('Scavenger_hunt_view', hunt);
                }
              };

              if (Platform.OS == 'android') {
                return (
                  <Marker
                    onPress={markerPress}
                    image={
                      location.featured
                        ? require('src/Images/Icons/featuredMapMarker.png')
                        : require('src/Images/Icons/mapMarkerAndroid.png')
                    }
                    identifier={`location_${location.hunt_id}`}
                    key={`location_${location.hunt_id}`}
                    coordinate={{
                      latitude: parseFloat(location.lat || 0),
                      longitude: parseFloat(location.long || 0),
                    }}>
                    <Callout
                      onPress={() => {
                        dispatch(setCurrentHunt(hunt));
                        navigationRef.navigate('ScavengerHuntInfoModal');
                        logCustomAnalyticsEvent('Scavenger_hunt_view', hunt);
                      }}>
                      <View style={{minWidth: 120}}>
                        <Text
                          style={{
                            fontFamily: global?.font.circular,
                            color: global?.color?.gray3,
                            textAlign: 'center',
                          }}>
                          {location.name}
                        </Text>
                      </View>
                    </Callout>
                  </Marker>
                );
              }
              return (
                <MapMarker
                  key={`location_${location.hunt_id}`}
                  lat={location.lat}
                  markerColor={
                    location.featured
                      ? global?.color?.yellow
                      : global?.color?.orange
                  }
                  long={location.long}
                  featured={location.featured}
                  title={location.name}
                  identifier={`${location.hunt_id}`}
                  showMarker={true}
                  markerPress={markerPress}
                />
              );
            }
          })}
      </MapViewCluster>

      <View style={{position: 'absolute', bottom: 0, left: 10}}>
        <DelayedLoad delay={200}>
          <CarouselView
            data={huntsList}
            intialMaxLength={20}
            selectedId={focusedLocationId}
            type={'hunt_card'}
            compact={true}
            renderWidth={280}
            handleSnapToMap={(location) => {
              console.log({location});
              handleSnapToMap(location, 0.01);
            }}
          />
        </DelayedLoad>
      </View>
    </View>
  );
};

export default HuntLandingMap;
